export default {
  status: 0,
  data: [
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000101',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 1,
      DIS_ITEM_NM: '아메리카노',
      DIS_ITEM_NM_KO: '아메리카노',
      DIS_ITEM_NM_EN: 'Americano',
      DIS_ITEM_NM_JP: 'アメリカーノ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000101',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/01.img_Americano.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진하게 로스팅한 원두에서 추출된 풍미 가득한 에스프레소 음료',
      ITEM_DESC_KO: '진하게 로스팅한 원두에서 추출된 풍미 가득한 에스프레소 음료',
      ITEM_DESC_JP: '深煎りのコーヒー豆から抽出した風味豊かなエスプレッソ飲料。',
      ITEM_DESC_EN: 'A flavorful espresso beverage extracted from darkly roasted coffee beans.',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000102',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 2,
      DIS_ITEM_NM: '콜드브루',
      DIS_ITEM_NM_KO: '콜드브루',
      DIS_ITEM_NM_EN: 'Cold Brew',
      DIS_ITEM_NM_JP: 'コールドブリュー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000102',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/02.img_ColdBrew.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '보다 부드럽고 깔끔한 콜드브루 커피',
      ITEM_DESC_KO: '보다 부드럽고 깔끔한 콜드브루 커피',
      ITEM_DESC_JP: 'よりスムーズでクリーンな水出しコーヒー',
      ITEM_DESC_EN: 'Smoother and cleaner cold brew coffee',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000103',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 3,
      DIS_ITEM_NM: '카페라떼',
      DIS_ITEM_NM_KO: '카페라떼',
      DIS_ITEM_NM_EN: 'Cafe Latte',
      DIS_ITEM_NM_JP: 'カフェラテ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000103',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/03.img_CafeLatte.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소와 스팀밀크 위에 부드러운우유가 더해진 라떼',
      ITEM_DESC_KO: '진한 에스프레소와 스팀밀크 위에 부드러운우유가 더해진 라떼',
      ITEM_DESC_JP: 'スチームミルクに濃厚なエスプレッソとソフトミルクを加えたラテ',
      ITEM_DESC_EN: 'Latte with rich espresso and soft milk on top of steamed milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000104',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 4,
      DIS_ITEM_NM: '카푸치노',
      DIS_ITEM_NM_KO: '카푸치노',
      DIS_ITEM_NM_EN: 'Cappuccino',
      DIS_ITEM_NM_JP: 'カプチーノ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000104',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/04.img_Cappuccino.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소와 스팀밀크 위에 시나몬가루가 더해진 커피',
      ITEM_DESC_KO: '진한 에스프레소와 스팀밀크 위에 시나몬가루가 더해진 커피',
      ITEM_DESC_JP: '濃厚なエスプレッソとスチームミルクにシナモンパウダーを加えたコーヒー',
      ITEM_DESC_EN: 'Coffee with cinnamon powder added on top of rich espresso and steamed milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000105',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 5,
      DIS_ITEM_NM: '카라멜\n마키아토',
      DIS_ITEM_NM_KO: '카라멜\n마키아토',
      DIS_ITEM_NM_EN: 'Caramel Macchiato',
      DIS_ITEM_NM_JP: 'キャラメルマキアート',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000105',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/05.img_CaramelMacchiato.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소에 바닐라 향과 카라멜소스가 드리즐된 달콤한 커피',
      ITEM_DESC_KO: '진한 에스프레소에 바닐라 향과 카라멜소스가 드리즐된 달콤한 커피',
      ITEM_DESC_JP: '濃いめのエスプレッソにバニラ風味とキャラメルソースをかけた甘いコーヒー。',
      ITEM_DESC_EN: 'Sweet coffee with strong espresso drizzled with vanilla flavor and caramel sauce.',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000106',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 6,
      DIS_ITEM_NM: '연유라떼',
      DIS_ITEM_NM_KO: '연유라떼',
      DIS_ITEM_NM_EN: 'Condensed milk latte',
      DIS_ITEM_NM_JP: '練乳ラテ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000106',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/06.img_CondensedMilkLatte.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소에 달콤한 연유와 부드러운 우유가 더해진 커피',
      ITEM_DESC_KO: '진한 에스프레소에 달콤한 연유와 부드러운 우유가 더해진 커피',
      ITEM_DESC_JP: '濃厚なエスプレッソと甘いコンデンスミルク、ソフトミルクを合わせたコーヒー',
      ITEM_DESC_EN: 'Coffee with rich espresso, sweet condensed milk, and soft milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000107',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 7,
      DIS_ITEM_NM: '헤이즐넛',
      DIS_ITEM_NM_KO: '헤이즐넛',
      DIS_ITEM_NM_EN: 'Hazelnut Latte',
      DIS_ITEM_NM_JP: 'ヘーゼルナッツラテ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000107',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/07.img_HazelnutLatte.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소에 부드럽고 고소한 헤이즐넛 시럽과 우유가 더해진 커피',
      ITEM_DESC_KO: '진한 에스프레소에 부드럽고 고소한 헤이즐넛 시럽과 우유가 더해진 커피',
      ITEM_DESC_JP: '濃厚なエスプレッソと柔らかく風味豊かなヘーゼルナッツシロップとミルクを合わせたコーヒー',
      ITEM_DESC_EN: 'Coffee with rich espresso, soft and savory hazelnut syrup and milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000108',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 8,
      DIS_ITEM_NM: '모카라떼',
      DIS_ITEM_NM_KO: '모카라떼',
      DIS_ITEM_NM_EN: 'Mocha Latte',
      DIS_ITEM_NM_JP: 'モカラテ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000108',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/08.img_MochaLatte.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소에 달콤한 초코시럽과 부드러운 우유가 더해진 커피',
      ITEM_DESC_KO: '진한 에스프레소에 달콤한 초코시럽과 부드러운 우유가 더해진 커피',
      ITEM_DESC_JP: '濃厚なエスプレッソと甘いチョコレートシロップ、柔らかなミルクを合わせたコーヒー',
      ITEM_DESC_EN: 'Coffee with rich espresso, sweet chocolate syrup, and soft milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '기본',
      DIS_ITEM_CD: '00000109',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 9,
      DIS_ITEM_NM: '스페니쉬',
      DIS_ITEM_NM_KO: '스페니쉬',
      DIS_ITEM_NM_EN: 'Spanish Cafe Latte',
      DIS_ITEM_NM_JP: 'スパニッシュカフェラテ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000109',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/coffee/09.img_SpanishCafeLatte.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 에스프레소에 달콤한 프리미엄 연유와 부드러운 우유가 더해진 커피',
      ITEM_DESC_KO: '진한 에스프레소에 달콤한 프리미엄 연유와 부드러운 우유가 더해진 커피',
      ITEM_DESC_JP: '濃厚なエスプレッソと甘いプレミアム練乳、ソフトミルクを合わせたコーヒー',
      ITEM_DESC_EN: 'Coffee with rich espresso, sweet premium condensed milk, and soft milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000111',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 11,
      DIS_ITEM_NM: '사과에이드',
      DIS_ITEM_NM_KO: '사과에이드',
      DIS_ITEM_NM_EN: 'Apple Ade',
      DIS_ITEM_NM_JP: 'アップルエイド',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000111',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/01.img_AppleAde.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '청량하고 달콤한 사과청을 넣은 유기농 사과에이드',
      ITEM_DESC_KO: '청량하고 달콤한 사과청을 넣은 유기농 사과에이드',
      ITEM_DESC_JP: '爽やかで甘いリンゴ果汁を使用した有機アップルエード',
      ITEM_DESC_EN: 'Organic appleade with refreshing and sweet apple juice',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000112',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 12,
      DIS_ITEM_NM: '블루에이드',
      DIS_ITEM_NM_KO: '블루에이드',
      DIS_ITEM_NM_EN: 'Blue Lemonade',
      DIS_ITEM_NM_JP: 'ブルーレモネード',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000112',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/02.img_BlueLemonade.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '프레시한 레몬과 상큼함을 더해줄 블루시럽이 조화로운 블루레몬에이드',
      ITEM_DESC_KO: '프레시한 레몬과 상큼함을 더해줄 블루시럽이 조화로운 블루레몬에이드',
      ITEM_DESC_JP: 'ブルー レモネードは、フレッシュなレモンとブルー シロップの調和のとれたブレンドで、さわやかさを加えています。',
      ITEM_DESC_EN: 'Blue Lemonade is a harmonious blend of fresh lemons and blue syrup for added refreshingness.',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000113',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 13,
      DIS_ITEM_NM: '레몬에이드 ',
      DIS_ITEM_NM_KO: '레몬에이드 ',
      DIS_ITEM_NM_EN: 'Lemonade',
      DIS_ITEM_NM_JP: 'レモネード',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000113',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/03.img_Lemonade.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4000,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '프레시한 레몬이 들어간 레몬에이드',
      ITEM_DESC_KO: '프레시한 레몬이 들어간 레몬에이드',
      ITEM_DESC_JP: 'フレッシュレモン入りレモネード',
      ITEM_DESC_EN: 'Lemonade with fresh lemons',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000114',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 14,
      DIS_ITEM_NM: '오렌지에이드',
      DIS_ITEM_NM_KO: '오렌지에이드',
      DIS_ITEM_NM_EN: 'Orange Ade',
      DIS_ITEM_NM_JP: 'オレンジエイド',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000114',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/04.img_OrangeAde.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '과육 가득한 오렌지를 담은 프레시한 오렌지 에이드',
      ITEM_DESC_KO: '과육 가득한 오렌지를 담은 프레시한 오렌지 에이드',
      ITEM_DESC_JP: 'オレンジの果肉がたっぷり入ったフレッシュオレンジエード',
      ITEM_DESC_EN: 'Fresh orange ade filled with orange flesh',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000115',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 15,
      DIS_ITEM_NM: '레드베리에이드',
      DIS_ITEM_NM_KO: '레드베리에이드',
      DIS_ITEM_NM_EN: 'Red Berry Ade',
      DIS_ITEM_NM_JP: 'レッドベリーエイド',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000115',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/05.img_RedBerryAde.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5600,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '상큼한 레드베리를 담고 청량한 탄산수를 더한 레드베리 에이드',
      ITEM_DESC_KO: '상큼한 레드베리를 담고 청량한 탄산수를 더한 레드베리 에이드',
      ITEM_DESC_JP: 'フレッシュなレッドベリーを配合し、爽やかな炭酸水を加えたレッドベリーエイド',
      ITEM_DESC_EN: 'Redberry Ade containing fresh red berries and adding refreshing carbonated water',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000116',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 16,
      DIS_ITEM_NM: '그레이프후르츠\n에이드',
      DIS_ITEM_NM_KO: '그레이프후르츠\n에이드',
      DIS_ITEM_NM_EN: 'Grapefruit Ade',
      DIS_ITEM_NM_JP: 'グレープフルーツエイド',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000116',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/06.img_GrapefruitAde.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '수제로 만든 그레이프프루트청으로 달큰하고 상큼한 에이드',
      ITEM_DESC_KO: '수제로 만든 그레이프프루트청으로 달큰하고 상큼한 에이드',
      ITEM_DESC_JP: '自家製グレープフルーツジュースを使用した甘くて爽やかなエード',
      ITEM_DESC_EN: 'Sweet and refreshing ade made with homemade grapefruit juice',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000117',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 17,
      DIS_ITEM_NM: '키위주스',
      DIS_ITEM_NM_KO: '키위주스',
      DIS_ITEM_NM_EN: 'Kiwi Juice',
      DIS_ITEM_NM_JP: 'キウイジュース',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000117',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/07.img_KiwiJuice.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '키위를 통째로 갈아만든 생과일 100% 키위주스',
      ITEM_DESC_KO: '키위를 통째로 갈아만든 생과일 100% 키위주스',
      ITEM_DESC_JP: 'キウイを丸ごと使った100％フレッシュキウイジュース',
      ITEM_DESC_EN: '100% fresh kiwi juice made from whole kiwis',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000118',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 18,
      DIS_ITEM_NM: '딸기주스',
      DIS_ITEM_NM_KO: '딸기주스',
      DIS_ITEM_NM_EN: 'Strawberry Juice',
      DIS_ITEM_NM_JP: 'イチゴジュース',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000118',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/08.img_StrawberryJuice.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '제철 생 딸기로 갈아만든 생과일 100% 딸기주스',
      ITEM_DESC_KO: '제철 생 딸기로 갈아만든 생과일 100% 딸기주스',
      ITEM_DESC_JP: '旬のフレッシュイチゴを使用した100％フレッシュイチゴジュース',
      ITEM_DESC_EN: '100% fresh strawberry juice made with seasonal fresh strawberries',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '에이드/주스',
      DIS_ITEM_CD: '00000119',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 19,
      DIS_ITEM_NM: '감귤에이드 ',
      DIS_ITEM_NM_KO: '감귤에이드 ',
      DIS_ITEM_NM_EN: 'Tangerine Ade',
      DIS_ITEM_NM_JP: 'タンジェリン・アデ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000119',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/ade/09.img_TangerineAde.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5600,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '과육 가득한 감귤을 담은 프레시한 감귤 에이드',
      ITEM_DESC_KO: '과육 가득한 감귤을 담은 프레시한 감귤 에이드',
      ITEM_DESC_JP: '肉厚のみかんがたっぷり入ったフレッシュみかんエイド',
      ITEM_DESC_EN: 'Fresh tangerine ade filled with fleshy tangerines',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000123',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 23,
      DIS_ITEM_NM: '망고 스무디',
      DIS_ITEM_NM_KO: '망고 스무디',
      DIS_ITEM_NM_EN: 'Mango Smoothie',
      DIS_ITEM_NM_JP: 'マンゴースムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000123',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/01.img_MangoSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '얼린 망고를 블렌더에갈아 만든 달콤하고 시원한 망고스무디',
      ITEM_DESC_KO: '얼린 망고를 블렌더에갈아 만든 달콤하고 시원한 망고스무디',
      ITEM_DESC_JP: '冷凍マンゴーをミキサーで粉砕した甘くて爽やかなマンゴースムージー。',
      ITEM_DESC_EN: 'Sweet and refreshing mango smoothie made by grinding frozen mango in a blender.',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000124',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 24,
      DIS_ITEM_NM: '말차스무디',
      DIS_ITEM_NM_KO: '말차스무디',
      DIS_ITEM_NM_EN: 'Matcha Smoothie',
      DIS_ITEM_NM_JP: '抹茶スムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000124',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/02.img_MatchaSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '제주 말차와 부드러운 밀크티가 들어간 말차스무디',
      ITEM_DESC_KO: '제주 말차와 부드러운 밀크티가 들어간 말차스무디',
      ITEM_DESC_JP: '済州抹茶とスムースミルクティーの抹茶スムージー',
      ITEM_DESC_EN: 'Matcha smoothie with Jeju matcha and smooth milk tea',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000125',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 25,
      DIS_ITEM_NM: '오레오밀크 스무디',
      DIS_ITEM_NM_KO: '오레오밀크 스무디',
      DIS_ITEM_NM_EN: 'Oreo Milk Smoothie',
      DIS_ITEM_NM_JP: 'オレオミルクスムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000125',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/03.img_OreoMilkSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '오레오 분태와 우유가 더해져 부드럽고 달콤한 오레오밀크스무디',
      ITEM_DESC_KO: '오레오 분태와 우유가 더해져 부드럽고 달콤한 오레오밀크스무디',
      ITEM_DESC_JP: 'オレオパウダーとミルクを加えた、ふんわり甘いオレオミルクスムージー',
      ITEM_DESC_EN: 'Soft and sweet Oreo Milk Smoothie with Oreo powder and milk added',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000126',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 26,
      DIS_ITEM_NM: '블루베리 스무디',
      DIS_ITEM_NM_KO: '블루베리 스무디',
      DIS_ITEM_NM_EN: 'Blueberry Smoothie',
      DIS_ITEM_NM_JP: 'ブルーベリースムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000126',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/04.img_BlueberrySmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '생 과일 블루베리를 부드러운 우유와 갈아만든 블루베리 스무디',
      ITEM_DESC_KO: '생 과일 블루베리를 부드러운 우유와 갈아만든 블루베리 스무디',
      ITEM_DESC_JP: '生ブルーベリーとまろやかなミルクをブレンドしたブルーベリースムージー',
      ITEM_DESC_EN: 'Blueberry smoothie made by blending raw blueberries with smooth milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000127',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 27,
      DIS_ITEM_NM: '메론 스무디',
      DIS_ITEM_NM_KO: '메론 스무디',
      DIS_ITEM_NM_EN: 'Melon Smoothie',
      DIS_ITEM_NM_JP: 'メロンスムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000127',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/05.img_MelonSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '맛있게 익은 메론과 시원한 우유를 갈아 만든 메론 스무디',
      ITEM_DESC_KO: '맛있게 익은 메론과 시원한 우유를 갈아 만든 메론 스무디',
      ITEM_DESC_JP: 'おいしい完熟メロンと冷たい牛乳をブレンドしたメロンスムージー',
      ITEM_DESC_EN: 'Melon smoothie made by blending delicious ripe melon and cool milk',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000128',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 28,
      DIS_ITEM_NM: '딸기 스무디',
      DIS_ITEM_NM_KO: '딸기 스무디',
      DIS_ITEM_NM_EN: 'Strawberry Smoothie',
      DIS_ITEM_NM_JP: 'ストロベリースムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000128',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/06.img_StrawberrySmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '상큼하고 달콤한 딸기를 갈아 만든 딸기 스무디',
      ITEM_DESC_KO: '상큼하고 달콤한 딸기를 갈아 만든 딸기 스무디',
      ITEM_DESC_JP: 'フレッシュで甘いイチゴを使ったストロベリースムージー',
      ITEM_DESC_EN: 'Strawberry smoothie made with fresh and sweet ground strawberries',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000129',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 29,
      DIS_ITEM_NM: '요거트 스무디',
      DIS_ITEM_NM_KO: '요거트 스무디',
      DIS_ITEM_NM_EN: 'Yogurt Smoothie',
      DIS_ITEM_NM_JP: 'ヨーグルトスムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000129',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/07.img_YogurtSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 5200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '락토프리 요거트로 만든 상큼한 요거트 스무디',
      ITEM_DESC_KO: '락토프리 요거트로 만든 상큼한 요거트 스무디',
      ITEM_DESC_JP: '無乳糖ヨーグルトを使用した爽やかなヨーグルトスムージー',
      ITEM_DESC_EN: 'Refreshing yogurt smoothie made with lactose-free yogurt',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '베버리지',
      DIS_ITEM_CD: '00000130',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 30,
      DIS_ITEM_NM: '퐁 스무디',
      DIS_ITEM_NM_KO: '퐁 스무디',
      DIS_ITEM_NM_EN: 'Pong Smoothie',
      DIS_ITEM_NM_JP: 'ポンスムージー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000130',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/beverage/08.img_PongSmoothie.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 6200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '우유에 죠리퐁 씨리얼이 믹싱 된 얼음을 갈아 만든 퐁 스무디',
      ITEM_DESC_KO: '우유에 죠리퐁 씨리얼이 믹싱 된 얼음을 갈아 만든 퐁 스무디',
      ITEM_DESC_JP: '砕いた氷にミルクとジョリーポンシリアルを混ぜたポンスムージー',
      ITEM_DESC_EN: 'Pong smoothie made with crushed ice mixed with milk and Jolly Pong cereal',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '차',
      DIS_ITEM_CD: '00000131',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 31,
      DIS_ITEM_NM: '블랙티',
      DIS_ITEM_NM_KO: '블랙티',
      DIS_ITEM_NM_EN: 'Black Tea',
      DIS_ITEM_NM_JP: '紅茶',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000131',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/tea/01.img_blacktea.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '피로회복과 스트레스 완화에 좋고 풍기가 짙은 홍차',
      ITEM_DESC_KO: '피로회복과 스트레스 완화에 좋고 풍기가 짙은 홍차',
      ITEM_DESC_JP: '疲労回復やストレス解消に効果的な香り豊かな紅茶',
      ITEM_DESC_EN: 'Black tea with a rich aroma that is good for recovering from fatigue and relieving stress',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '차',
      DIS_ITEM_CD: '00000132',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 32,
      DIS_ITEM_NM: '복숭아아이스티',
      DIS_ITEM_NM_KO: '복숭아아이스티',
      DIS_ITEM_NM_EN: 'Iced Tea',
      DIS_ITEM_NM_JP: 'アイスティー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000132',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/tea/02.img_IcedTea.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4000,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '달고 시원한 복숭아맛 아이스티',
      ITEM_DESC_KO: '달고 시원한 복숭아맛 아이스티',
      ITEM_DESC_JP: '甘くて爽やかなピーチ風味のアイスティー',
      ITEM_DESC_EN: 'Sweet and refreshing peach-flavored ice tea',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '차',
      DIS_ITEM_CD: '00000133',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 33,
      DIS_ITEM_NM: '얼그레이티',
      DIS_ITEM_NM_KO: '얼그레이티',
      DIS_ITEM_NM_EN: 'Earl Gray Tea',
      DIS_ITEM_NM_JP: 'アールグレイティー',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000133',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/tea/03.img_EarlGrayTea.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '시트러스 과일과 수레국화 양이 더해진 얼그레이티',
      ITEM_DESC_KO: '시트러스 과일과 수레국화 양이 더해진 얼그레이티',
      ITEM_DESC_JP: '柑橘類とヤグルマギクの種を加えたアールグレイティー',
      ITEM_DESC_EN: 'Earl gray tea with added citrus fruits and cornflower seeds',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '차',
      DIS_ITEM_CD: '00000134',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 34,
      DIS_ITEM_NM: '녹차',
      DIS_ITEM_NM_KO: '녹차',
      DIS_ITEM_NM_EN: 'Green tea',
      DIS_ITEM_NM_JP: '緑茶',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000134',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/tea/04.img_PeppermintTea.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '고소한 감칠맛과 부드러움,산뜻함이 느껴지는 녹차',
      ITEM_DESC_KO: '고소한 감칠맛과 부드러움,산뜻함이 느껴지는 녹차',
      ITEM_DESC_JP: 'ナッツの風味、柔らかさ、爽やかな味わいの緑茶',
      ITEM_DESC_EN: 'Green tea with a nutty flavor, softness, and refreshing taste',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000135',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 35,
      DIS_ITEM_NM: '바나나 와플',
      DIS_ITEM_NM_KO: '바나나 와플',
      DIS_ITEM_NM_EN: 'Banana Waffles',
      DIS_ITEM_NM_JP: 'バナナワッフル',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000135',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/01.img_Bananawaffles.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '슬라이스된 바나나와 휘핑크림,카라멜 시럽이 드리즐된 바나나와플',
      ITEM_DESC_KO: '슬라이스된 바나나와 휘핑크림,카라멜 시럽이 드리즐된 바나나와플',
      ITEM_DESC_JP: 'スライスバナナ、ホ​​イップクリーム、キャラメルシロップを添えたバナナワッフル',
      ITEM_DESC_EN: 'Banana waffle with sliced ​​bananas, whipped cream, and caramel syrup drizzle',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000136',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 36,
      DIS_ITEM_NM: '브렉퍼스트 샌드위치',
      DIS_ITEM_NM_KO: '브렉퍼스트 샌드위치',
      DIS_ITEM_NM_EN: 'Breakfast Sandwich',
      DIS_ITEM_NM_JP: '朝食サンドイッチ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000136',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/02.img_Breakfastsandwich.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '신선한 야채와 맛있는 슬라이스 햄이 들어간 든든한 샌드위치',
      ITEM_DESC_KO: '신선한 야채와 맛있는 슬라이스 햄이 들어간 든든한 샌드위치',
      ITEM_DESC_JP: '新鮮な野菜とおいしいスライスハムのボリュームたっぷりのサンドイッチ',
      ITEM_DESC_EN: 'Hearty sandwich with fresh vegetables and delicious sliced ​​ham',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000137',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 37,
      DIS_ITEM_NM: '초콜렛 무스케이크',
      DIS_ITEM_NM_KO: '초콜렛 무스케이크',
      DIS_ITEM_NM_EN: 'Chocolate Mousse Cake',
      DIS_ITEM_NM_JP: 'チョコレートムースケーキ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000137',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/03.img_Chocolatemoussecake.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진한 초코의 맛을 느낄 수 있는 초콜릿 무스 케이크',
      ITEM_DESC_KO: '진한 초코의 맛을 느낄 수 있는 초콜릿 무스 케이크',
      ITEM_DESC_JP: '濃厚なチョコレートの味わいが楽しめるチョコレートムースケーキ',
      ITEM_DESC_EN: 'Chocolate mousse cake with rich chocolate taste',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000138',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 38,
      DIS_ITEM_NM: '초코머핀',
      DIS_ITEM_NM_KO: '초코머핀',
      DIS_ITEM_NM_EN: 'Chocolate Muffin',
      DIS_ITEM_NM_JP: 'チョコレートマフィン',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000138',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/04.img_Chocolatemuffin.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '진하고 달콤한 초코머핀위에 초코크림이 더해진 환상의 머핀',
      ITEM_DESC_KO: '진하고 달콤한 초코머핀위에 초코크림이 더해진 환상의 머핀',
      ITEM_DESC_JP: '濃厚な甘さのチョコレートマフィンの上にチョコレートクリームを加えた幻想的なマフィンです。',
      ITEM_DESC_EN: 'A fantastic muffin with chocolate cream added on top of a rich and sweet chocolate muffin.',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000139',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 39,
      DIS_ITEM_NM: '도너츠',
      DIS_ITEM_NM_KO: '도너츠',
      DIS_ITEM_NM_EN: 'Donut',
      DIS_ITEM_NM_JP: 'ドーナツ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000139',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/05.img_Donut.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 2400,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '폭신한 바닐라빵에 베이킹 파우더가 뒤 덮힌 도너츠',
      ITEM_DESC_KO: '폭신한 바닐라빵에 베이킹 파우더가 뒤 덮힌 도너츠',
      ITEM_DESC_JP: 'ふわふわのバニラパンにベーキングパウダーが覆われたドーナツ',
      ITEM_DESC_EN: 'Donuts covered in fluffy vanilla bread and baking powder',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000140',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 40,
      DIS_ITEM_NM: '잠봉뵈르 베이글',
      DIS_ITEM_NM_KO: '잠봉뵈르 베이글',
      DIS_ITEM_NM_EN: 'Jambon Beurre',
      DIS_ITEM_NM_JP: 'ジャンボン ブール',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000140',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/06.img_JambonBeurre.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '고소한 베이글 사이에 잠봉뵈르 햄과 치즈를 샌드한 베이글',
      ITEM_DESC_KO: '고소한 베이글 사이에 잠봉뵈르 햄과 치즈를 샌드한 베이글',
      ITEM_DESC_JP: 'ジャンボンボーのハムとチーズを風味豊かなベーグルで挟んだベーグル',
      ITEM_DESC_EN: 'Bagel with Jambonbör ham and cheese sandwiched between savory bagels',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000141',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 41,
      DIS_ITEM_NM: '바닐라스콘',
      DIS_ITEM_NM_KO: '바닐라스콘',
      DIS_ITEM_NM_EN: 'Scone',
      DIS_ITEM_NM_JP: 'スコーン',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000141',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/07.img_Scone.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 3200,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '프랑스산 고급 버터로 만든 담백하고 고소한 바닐라 스콘',
      ITEM_DESC_KO: '프랑스산 고급 버터로 만든 담백하고 고소한 바닐라 스콘',
      ITEM_DESC_JP: 'フランス産高級バターを使用した軽くて風味豊かなバニラスコーン',
      ITEM_DESC_EN: 'Light and savory vanilla scones made with premium French butter',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000142',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 42,
      DIS_ITEM_NM: '딸기 조각케이크 ',
      DIS_ITEM_NM_KO: '딸기 조각케이크 ',
      DIS_ITEM_NM_EN: 'Strawberry Cake',
      DIS_ITEM_NM_JP: 'ストロベリーケーキ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000142',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/08.img_StrawberryCake.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4800,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '생딸기가 생크림과 층으로 쌓여 달콤한 딸기 케이크',
      ITEM_DESC_KO: '생딸기가 생크림과 층으로 쌓여 달콤한 딸기 케이크',
      ITEM_DESC_JP: 'フレッシュなイチゴとホイップクリームを重ねた甘いイチゴケーキ',
      ITEM_DESC_EN: 'Sweet strawberry cake with fresh strawberries layered with whipped cream',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
    {
      CP_CD: '0801',
      STORE_CD: '0001',
      TNANT_CD: '0009',
      KOS_CLASS_CD: '푸드',
      DIS_ITEM_CD: '00000143',
      SHOP_ID: '0003809',
      DIS_ITEM_ORDER: 43,
      DIS_ITEM_NM: '딸기 롤케이크',
      DIS_ITEM_NM_KO: '딸기 롤케이크',
      DIS_ITEM_NM_EN: 'Strawberry roll Cake',
      DIS_ITEM_NM_JP: 'いちごのロールケーキ',
      DIS_ITEM_NM_CN: '',
      DIS_ITEM_NM_TW: '',
      TAG: '',
      RECMD_YN: 'Y',
      SUB_ITEM_CD: '00000143',
      REP_YN: 'Y',
      SUB_ITEM_IMG_FILE_ID: '2122375152',
      SUB_ITEM_IMG_FILE_URL: require('../../../assets/images/beverage/product/food/09.img_Strawberryrollcake.png'),
      CURR_UNIT: '001',
      CURR_UNIT_TEXT: '원',
      ITEM_ADD_INFO: '',
      SALE_UPRC: 4500,
      SVC_RATE: 0,
      CLAS_L_CD: '001',
      CLAS_M_CD: '001',
      CLAS_S_CD: '001',
      TAX_FLG_CD: '1',
      TAX_RDC_CD: '00',
      TAX_RDC_FLG_CD: '00',
      OPT_GRP_CD: '001',
      DC_ABLE_YN: 'Y',
      ERP_ITEM_CD: '',
      TAX_RATE: 10,
      SUPY_UPRC: 0,
      MG_RATE: 100,
      ALLERGY_LIST: '01,02,03',
      CAL: 0,
      NAT: 0,
      CARBO: 0,
      SUGAR: 0,
      FAT: 0,
      TRANS: 0,
      CHOL: 0,
      PROTEIN: 0,
      CAFF: 0,
      ITEM_DESC: '폭신한 빵에 생딸기와 딸기 크림이 발라진 롤케이크',
      ITEM_DESC_KO: '폭신한 빵에 생딸기와 딸기 크림이 발라진 롤케이크',
      ITEM_DESC_JP: 'ふわふわのパンにフレッシュなイチゴとイチゴクリームをのせたロールケーキ',
      ITEM_DESC_EN: 'Roll cake with fresh strawberries and strawberry cream spread on fluffy bread',
      ITEM_DESC_CN: '',
      ITEM_DESC_TW: '',
      SLDOUT_YN: 'N',
      LIQUOR_YN: 'N',
      HARM_YN: 'N',
      EVNT_NM: null,
      EVNT_KIND_CD: null,
      EVNT_FROM_DATE: null,
      EVNT_END_DATE: null,
      EVNT_FLG_CD: null,
      TIME_SALE_YN: null,
      TIME_SALE_FROM_TIME: null,
      TIME_SALE_END_TIME: null,
      EVNT_CD: null,
      EVNT_ITEM_CD: null,
      EVNT_DC_FLG_CD: null,
      EVNT_DC_AMT: null,
    },
  ],
  message: '',
};
